import { render, staticRenderFns } from "./SearchTabsTheme2.vue?vue&type=template&id=4ff49446"
import script from "./SearchTabsTheme2.vue?vue&type=script&lang=js"
export * from "./SearchTabsTheme2.vue?vue&type=script&lang=js"
import style0 from "./SearchTabsTheme2.vue?vue&type=style&index=0&id=4ff49446&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports